import find from 'lodash/find'
import filter from 'lodash/filter'
import Service from '@models/Service/model'
import Collection from '@models/Collection'

export default class ServiceCollection extends Collection {
  findCurrentService () {
    return find(this.$models, { current: true })
  }

  findPortalService () {
    return find(this.$models, { portal: true })
  }

  findAvailableServices () {
    return filter(this.$models, { portal: false })
  }

  getModel () {
    return Service
  }
}



// WEBPACK FOOTER //
// ./src/models/Service/collection.js